// extracted by mini-css-extract-plugin
export var Container = "index-module--Container--tVyJw";
export var Hero = "index-module--Hero--28sVh";
export var HeroButtonContainer = "index-module--HeroButtonContainer--aruVs";
export var ButtonArrow = "index-module--ButtonArrow--IoQRp";
export var SectionContainer = "index-module--SectionContainer--LsI6K";
export var SectionName = "index-module--SectionName--XF-du";
export var SectionContent = "index-module--SectionContent--t7Al4";
export var Footer = "index-module--Footer--i6rtP";
export var FooterContactItem = "index-module--FooterContactItem--Fx3IE";